import React, { FC } from 'react';

import { Outlet } from 'react-router-dom';

import { ProjectDirectoryLayout } from '@adsk/alloy-project-page-layout';
import { TabTitle } from '@adsk/exo-skeleton-react';

import ProjectsHeader from './ProjectsHeader';
import AlloyContextSubscriber from '../../components/AlloyContextSubscriber';
import { ConnectedAnnouncementBanner } from '../../components/AnnouncementBanner/ConnectedAnnouncementBanner';
import RemoteComponent from '../../components/RemoteComponent/RemoteComponent';

const OutletContainer: FC = () => {
  return (
    <>
      <RemoteComponent
        scope="accProjectList"
        module="./ProductLinks"
        renderLoader={() => null}
      />
      <ProjectsHeader />
      <Outlet />
    </>
  );
};

const Projects = () => {
  return (
    <ProjectDirectoryLayout
      renderAboveLayout={() => <ConnectedAnnouncementBanner />}
    >
      <TabTitle />
      <RemoteComponent scope="accProjectList" module="./ProvidersContainer">
        <AlloyContextSubscriber>
          <OutletContainer />
        </AlloyContextSubscriber>
      </RemoteComponent>
    </ProjectDirectoryLayout>
  );
};

export default Projects;
